// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// إعدادات Firebase الخاصة بمشروعك
const firebaseConfig = {
  apiKey: "AIzaSyC9MBjo5LWpiK9EMtTO-XZpkgWtjrgLizQ",
  authDomain: "iisd-7beff.firebaseapp.com",
  projectId: "iisd-7beff",
  storageBucket: "iisd-7beff.appspot.com",
  messagingSenderId: "546777693957",
  appId: "1:546777693957:web:a760e82d31d9b4df88016c",
  measurementId: "G-CLE408NCGV",
};

// تهيئة التطبيق
const app = initializeApp(firebaseConfig);

// إعداد Firestore و Storage
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
